<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <material-header
                title="Rewards"
                info="Manage rewards, gift cards and redemption options"
                help="rewards"
                :loading="loading"
                icon="mdi-star-circle">

            <template slot="buttons">

                <v-tooltip color="primary" left v-if="hasPermission(minPermission)">
                    <template v-slot:activator="{ on }">
                        <v-btn @click="loadPartners(true, true)" v-on="on" icon>
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>Reload reward partners</span>
                </v-tooltip>

            </template>

        </material-header>

        <v-alert type="error" class="body-2" v-if="!hasPermission(minPermission)">
            Your user account doesn't have sufficient permissions for this feature
        </v-alert>

        <v-card flat class="pa-4" v-if="hasPermission(minPermission)">

            <!-- TANGO CARD CONTROL PANEL-->
            <tango-card-control-panel></tango-card-control-panel>

            <!-- PAYPAL CONTROL PANEL -->
            <pay-pal-control-panel class="mt-2"></pay-pal-control-panel>

        </v-card>

    </v-container>
</template>

<script>

    import Json from 'vue-json-pretty';
    import Store from '../store';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import {mapActions} from "vuex";
    import TangoCardControlPanel from "./TangoCard/TangoCardControlPanel";
    import PayPalControlPanel from "./PayPal/PayPalControlPanel";

    const vuexModule = 'Rewards';

    export default {

        mixins: [activeSessionChecker],

        components: {
            Json,
            MaterialHeader,
            TangoCardControlPanel,
            PayPalControlPanel
        },

        data() {
            return {
                minPermission: 'view rewards',
                activeTabModel: null,
                loading: false,
            }
        },

        watch: {
            $route(to) {
                if (to.name === 'rewards') {
                    this.loadPartners();
                }
            }
        },

        methods: {

            ...mapActions(vuexModule, [
                'getPartners'
            ]),

            loadPartners(showSuccess = false, force = false) {

                this.loading = true;

                this.getPartners(force)
                    .then(response => {
                        if (showSuccess) {
                            Bus.$emit('flash-message', {message: 'Reward partners reloaded!'});
                        }
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {type: 'error', message: 'OOPS! Reward partners failed to load!'});
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        },

        mounted() {
            this.loadPartners();
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }
        },
    }

</script>
